import { Input } from "@/components/ui/input";
import { useDebounceCallback } from "@/shared/hooks/use-debounce-callback";
import { SimpleSelect } from "@/shared/ui/SimpleSelect";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { XIcon } from "lucide-react";
import { useEffect, useState } from "react";

export type SuppliersSearch = {
  search?: string;
  isActive?: string;
  offset?: number;
  limit?: number;
  sortField?: string;
  sortOrder?: "asc" | "desc";
};

export function SuppliersFilter() {
  const nav = useNavigate({ from: "/app/inventory/suppliers" });
  const search = useSearch({
    from: "/app/inventory/suppliers",
  }) as SuppliersSearch;

  const [searchValue, setSearchValue] = useState(search.search ?? "");

  useEffect(() => {
    setSearchValue(search.search ?? "");
  }, [search.search]);

  const debounced = useDebounceCallback((val: string) => {
    setSearchValue(val);
    nav({
      search: {
        ...search,
        offset: 0,
        search: val.trim() ? val.trim() : undefined,
      },
    });
  }, 400);

  const isActiveValue = search.isActive ?? "all";
  const hasFilter = !!search.search?.trim() || isActiveValue !== "all";

  return (
    <div className="flex flex-wrap items-center gap-2 border-b px-4 pb-2">
      <Input
        placeholder="ຄົ້ນຫາຊື່ ຫຼື ລະຫັດ..."
        defaultValue={searchValue}
        onChange={(e) => debounced(e.target.value)}
        className="max-w-xs"
      />
      <SimpleSelect
        placeholder="ສະຖານະ"
        value={isActiveValue}
        onValueChange={(v) => {
          nav({
            search: {
              ...search,
              offset: 0,
              isActive: v === "all" ? undefined : v,
            },
          });
        }}
        options={[
          { value: "all", label: "ທັງໝົດ" },
          { value: "true", label: "ເປີດໃຊ້" },
          { value: "false", label: "ປິດໃຊ້" },
        ]}
      />
      {hasFilter && (
        <button
          type="button"
          className="inline-flex items-center gap-1 text-muted-foreground text-sm hover:text-foreground"
          onClick={() =>
            nav({
              search: { offset: 0, limit: search.limit },
            })
          }
        >
          <XIcon className="size-4" />
          ລ້າງຕົວກອງ
        </button>
      )}
    </div>
  );
}
